import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import "yet-another-react-lightbox/styles.css";
import Lightbox from 'yet-another-react-lightbox';
import Zoom from "yet-another-react-lightbox/plugins/zoom";

function HotelGalleryViewModel(props:any) {
    const {
        galleryViewData,
        galleryviewModal,
        setGalleryViewModal
    } = props

    const closeModal = () => {
        setGalleryViewModal(!galleryviewModal)
    }

    const [isOpenGallery, setIsOpenGallery] = useState(false);
    const [indexGallery, setIndexGallery] = useState(1);
    const [srcGallery, setSrcGallery] = useState<any>([]);

    const onClickHandler = (e:any) => {
        galleryViewData?.map((value:any) => {
            setSrcGallery((current:any) => [...current, { ...srcGallery, src: value }])
        })
        setIsOpenGallery(true);
        setIndexGallery(e)
    }

    return (
        <Modal
            show={galleryviewModal}
            onHide={() => closeModal()}
            dialogClassName="modal-90w"
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >

            <div className="modal-header py-2 border-0 row mx-0 mt-2 justify-content-end">
                <div className="col-auto ps-0">
                    <button type="button"
                        id="closemodal"
                        className="btn-close closebtn_popup_position_gallery"
                        onClick={() => closeModal()}
                    >
                    </button>
                </div>
            </div>

            <div className="modal-body mb-2"
                style={{ overflow: "auto", height: "85vh" }}>
                <div className='row'>
                    {galleryViewData?.length > 0 && galleryViewData.map((img:any, index:any) => (

                        <div key={index} className="col-lg-4 col-sm-6 py-2 col-12 cursor_pointer"
                            onClick={(e) => onClickHandler(index)}
                        >
                            <img
                                loading='lazy'
                                src={img}
                                className='w-100'
                                style={{ "height": "263px", "objectFit": "fill" }}
                                onError={(e:any) => e.target.src = require("../../../../assets/img/no-image.png")}
                                alt=''
                            />
                        </div>
                    ))}
                </div>

            </div>

            {isOpenGallery && (
                <>
                    <Lightbox
                        slides={srcGallery}
                        open={indexGallery >= 0}
                        index={indexGallery}
                        close={() => { setIndexGallery(-1); setSrcGallery([]); }}
                        plugins={[Zoom]}
                        zoom={{
                            zoomInMultiplier: 2,
                            doubleTapDelay: 300,
                            doubleClickDelay: 300,
                            doubleClickMaxStops: 2,
                            keyboardMoveDistance: 50,
                            wheelZoomDistanceFactor: 100,
                            pinchZoomDistanceFactor: 100,
                            maxZoomPixelRatio: 5,
                        }}
                    />

                </>
            )}
        </Modal>
    )
}

export default HotelGalleryViewModel